module.exports = __webpack_public_path__ + "img/boy.d436538e.png";